import React, { useEffect, useState } from "react";
import { Truck, Clock } from "@phosphor-icons/react";

/**
 * Shows a "dispatch by X · arrives Y" line + a live countdown to the daily
 * order-cutoff (default: 15:00 SAST). Purely presentational — no backend.
 */
const CUTOFF_HOUR = 15; // (unused after 48-72hr rewrite; kept for future use)

function skipWeekend(d) {
  const day = d.getDay();
  if (day === 6) d.setDate(d.getDate() + 2);
  else if (day === 0) d.setDate(d.getDate() + 1);
  return d;
}
function fmtDay(d) {
  return d.toLocaleDateString("en-ZA", { weekday: "short", day: "numeric", month: "short" });
}

export default function DeliveryETA() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  // Dispatch: within 1 business day of ordering
  let dispatch = skipWeekend(new Date(now.getTime() + 24 * 3600 * 1000));
  // Arrival window: dispatch + 2 business days (48hr min), and dispatch + 3 (72hr max)
  let arriveMin = skipWeekend(new Date(dispatch.getTime() + 24 * 3600 * 1000));
  let arriveMax = skipWeekend(new Date(dispatch.getTime() + 48 * 3600 * 1000));

  return (
    <div
      data-testid="delivery-eta"
      className="border border-white/10 bg-[#0d0d0d] p-4"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <div className="inline-flex h-9 w-9 items-center justify-center border border-white/15 bg-black">
            <Truck size={16} weight="duotone" className="text-[#00FFC2]" />
          </div>
          <div>
            <div className="font-label text-[9px] tracking-widest text-[#00FFC2]">
              / DISPATCH & DELIVERY
            </div>
            <div className="mt-0.5 text-sm text-white/90">
              Dispatch <b className="text-white">{fmtDay(dispatch)}</b>
              <span className="text-white/40"> · </span>
              Arrives <b className="text-[#00FFC2]">{fmtDay(arriveMin)}–{fmtDay(arriveMax)}</b>
            </div>
          </div>
        </div>

        <div
          data-testid="cutoff-countdown"
          className="inline-flex items-center gap-2 border border-[#FFC900]/50 bg-[#FFC900]/5 px-3 py-2"
        >
          <Clock size={13} weight="fill" className="text-[#FFC900]" />
          <span className="font-label text-[10px] tracking-wider text-[#FFC900]">
            48-72 HOURS
          </span>
        </div>
      </div>
    </div>
  );
}
